module.exports = __webpack_public_path__ + "static/media/heldane-text-web-regular-italic.4630d323.woff";